














import SharedFunctions from '../SharedFunctions'
import { Component } from 'vue-property-decorator'

@Component({})
export default class StatementResidentNavigation extends SharedFunctions {
  get show () {
    return this.selectedStatement && !this.mailedStatuses.includes(this.selectedStatement.status)
  }
}
